export default "__VITE_ASSET__rFs3aBHn__"